import { HelmetProvider } from "react-helmet-async";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

/**
 * Wraps the application in react-helmet-async's HelmetProvider.
 * Enables dynamic <head> management for SEO across all routes.
 */
export function AppHelmetProvider({ children }: Props) {
  return <HelmetProvider>{children}</HelmetProvider>;
}
